module.exports = __webpack_public_path__ + "static/media/search.309dd627.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.svg
// module id = ./src/assets/search.svg
// module chunks = 0